/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { ISummaryTableColumn } from './SummaryTable';

export const columnsMetaData: ISummaryTableColumn[] = [
  {
    field: 'accountNumber',
    isSelected: true,
    isTabulated: true,
    isListed: true,
    initialWidth: '14rem'
  },
  {
    field: 'billingCycle',
    isSelected: true,
    isTabulated: true,
    isListed: true,
    initialWidth: '14rem'
  },
  {
    field: 'period',
    isSelected: true,
    isTabulated: true,
    isListed: true,
    initialWidth: '8rem'
  },
  {
    field: 'totalcost',
    sortable: true,
    isSelected: true,
    isTabulated: true,
    order: 1,
    isListed: true,
    costField: true,
    initialWidth: '11rem'
  },
  {
    field: 'consumption',
    sortable: true,
    isSelected: true,
    isTabulated: true,
    order: 2,
    isListed: true,
    initialWidth: '13rem'
  },
  {
    field: 'consumptioncost',
    sortable: true,
    isSelected: true,
    isTabulated: true,
    order: 3,
    isListed: true,
    costField: true,
    initialWidth: '15rem'
  },
  {
    field: 'demand',
    sortable: true,
    isSelected: true,
    isTabulated: true,
    order: 4,
    isListed: true,
    initialWidth: '13rem'
  },
  {
    field: 'demandcharges',
    sortable: true,
    isSelected: true,
    isTabulated: true,
    order: 5,
    isListed: true,
    costField: true,
    initialWidth: '13rem'
  },

  {
    field: 'recordeddemand',
    sortable: true,
    isSelected: true,
    isTabulated: true,
    order: 4,
    isListed: true,
    initialWidth: '14rem'
  },
  {
    field: 'servicecharges',
    sortable: true,
    isSelected: true,
    isTabulated: true,
    order: 6,
    isListed: true,
    costField: true,
    initialWidth: '14rem'
  },
  {
    field: 'billingdemand',
    sortable: true,
    isSelected: true,
    isTabulated: true,
    order: 4,
    isListed: true,
    initialWidth: '13rem'
  },
  {
    field: 't&dcost',
    sortable: true,
    isSelected: true,
    isTabulated: true,
    order: 7,
    isListed: true,
    costField: true,
    initialWidth: '10rem'
  },
  {
    field: 'fixed',
    sortable: true,
    isSelected: false,
    isTabulated: false,
    order: 8,
    isListed: false,
    costField: true,
    initialWidth: '13rem'
  },
  {
    field: 'penalties',
    sortable: true,
    isSelected: false,
    isTabulated: false,
    order: 9,
    isListed: false,
    costField: true,
    initialWidth: '13rem'
  },
  {
    field: 'taxes',
    sortable: true,
    isSelected: false,
    isTabulated: false,
    order: 10,
    isListed: false,
    costField: true,
    initialWidth: '12rem'
  },
  {
    field: 'others',
    sortable: true,
    isSelected: true,
    isTabulated: true,
    order: 11,
    isListed: true,
    costField: true,
    initialWidth: '10rem'
  }
];

export const columnsMetaDataForOtherUtility: ISummaryTableColumn[] = [
  {
    field: 'accountNumber',
    isSelected: true,
    isTabulated: true,
    isListed: true,
    initialWidth: '14rem'
  },
  {
    field: 'billingCycle',
    isSelected: true,
    isTabulated: true,
    isListed: true,
    initialWidth: '14rem'
  },
  {
    field: 'period',
    isSelected: true,
    isTabulated: true,
    isListed: true,
    initialWidth: '8rem'
  },
  {
    field: 'totalcost',
    sortable: true,
    isSelected: true,
    isTabulated: true,
    order: 1,
    isListed: true,
    costField: true,
    initialWidth: '10rem'
  },
  {
    field: 'consumption',
    sortable: true,
    isSelected: true,
    isTabulated: true,
    order: 2,
    isListed: true,
    initialWidth: '11rem'
  },
  {
    field: 'consumptioncharge',
    sortable: true,
    isSelected: true,
    isTabulated: true,
    order: 3,
    isListed: true,
    costField: true,
    initialWidth: '10rem'
  },
  {
    field: 'demand',
    sortable: true,
    isSelected: true,
    isTabulated: true,
    order: 4,
    isListed: true,
    initialWidth: '13rem'
  },
  {
    field: 'demandcharges',
    sortable: true,
    isSelected: true,
    isTabulated: true,
    order: 5,
    isListed: true,
    costField: true,
    initialWidth: '13rem'
  },

  {
    field: 'recordeddemand',
    sortable: true,
    isSelected: true,
    isTabulated: true,
    order: 4,
    isListed: true,
    initialWidth: '14rem'
  },
  {
    field: 'servicecharges',
    sortable: true,
    isSelected: true,
    isTabulated: true,
    order: 6,
    isListed: true,
    costField: true,
    initialWidth: '14rem'
  },
  {
    field: 'billingdemand',
    sortable: true,
    isSelected: true,
    isTabulated: true,
    order: 4,
    isListed: true,
    initialWidth: '13rem'
  },
  {
    field: 't&dcost',
    sortable: true,
    isSelected: true,
    isTabulated: true,
    order: 7,
    isListed: true,
    costField: true,
    initialWidth: '10rem'
  },
  {
    field: 'fixed',
    sortable: true,
    isSelected: false,
    isTabulated: false,
    order: 8,
    isListed: false,
    costField: true,
    initialWidth: '13rem'
  },
  {
    field: 'penalties',
    sortable: true,
    isSelected: false,
    isTabulated: false,
    order: 9,
    isListed: false,
    costField: true,
    initialWidth: '13rem'
  },
  {
    field: 'taxes',
    sortable: true,
    isSelected: false,
    isTabulated: false,
    order: 10,
    isListed: false,
    costField: true,
    initialWidth: '12rem'
  },
  {
    field: 'others',
    sortable: true,
    isSelected: true,
    isTabulated: true,
    order: 11,
    isListed: true,
    costField: true,
    initialWidth: '9rem'
  }
];
